import {AuthenticationController} from "../../../../backends/YiiRoutes";
import Button from "../../../utilities/Button";
import {useContext} from "react";
import {StoreContext} from "../../../../stores/StoreLoader";

export function LogoutButton(props) {
    const {interfaceStore, userStore, i18nStore} = useContext(StoreContext);

    if (interfaceStore.isSchoolBlocks) {
        return <Button onClick={() => {
            userStore.logout();
            window.location.href = AuthenticationController.logout(i18nStore.currentOrgSupportedLocale);
        }} {...props}>{props.children}</Button>
    } else {
        return <Button onClick={userStore.logout} {...props}>{props.children}</Button>
    }
}